module.exports = __webpack_public_path__ + "media/landing-page/globe-3acae08d.png";